import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import ArticleCard from '@/components/feature/ArticleCard';
import SectionHeading from '@/components/feature/SectionHeading';

export default function FeaturedEvents() {
  const top = articles.find((a) => a.isTop) ?? articles[0];
  const rest = articles.filter((a) => a.slug !== top.slug && !a.isTop).slice(0, 3);
  const topCategory = categories.find((c) => c.slug === top.categorySlug);

  return (
    <section id="events" className="w-full bg-background-50 py-12 md:py-16 scroll-mt-32">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="热门事件"
          title="今天大家都在讨论什么"
          description="精选当日讨论量最高的事件，附上关键要点速览，先看结论再决定要不要细读。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Link
            to={`/article/${top.slug}`}
            className="group relative block rounded-lg overflow-hidden border border-background-200 cursor-pointer"
          >
            <div className="w-full h-64 md:h-[420px]">
              <img
                src={top.cover}
                alt={`${top.title} · 17c吃瓜今日头条配图`}
                title={`${top.title} · 今日热门事件`}
                className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-4 md:p-6">
              <div className="flex items-center gap-2 mb-2.5 flex-wrap">
                <span className="px-2 py-0.5 text-[11px] rounded-full bg-primary-500 text-background-50">
                  {topCategory?.name}
                </span>
                <span className="px-2 py-0.5 text-[11px] rounded-full bg-background-50/20 text-background-50 backdrop-blur-sm">
                  <i className="ri-fire-fill mr-0.5 text-secondary-300"></i>热度 {top.heat}
                </span>
                <span className="px-2 py-0.5 text-[11px] rounded-full bg-background-50/20 text-background-50 backdrop-blur-sm">
                  {top.views} 阅读
                </span>
              </div>
              <h3 className="font-heading text-xl md:text-3xl font-black text-background-50 leading-snug">
                {top.title}
              </h3>
              <p className="mt-2.5 text-sm text-background-200 leading-relaxed line-clamp-2 max-w-2xl">
                {top.subtitle}
              </p>
            </div>
          </Link>

          <div className="flex flex-col gap-4">
            {rest.map((item) => (
              <ArticleCard key={item.slug} article={item} variant="wide" />
            ))}
            <Link
              to="/category/entertainment"
              className="mt-auto flex items-center justify-between rounded-lg border border-dashed border-background-300 px-4 py-3.5 hover:border-primary-300 hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <span className="text-sm text-foreground-700">浏览全部栏目与历史事件</span>
              <i className="ri-arrow-right-line text-primary-600"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}